import { useState } from "react";
import { useNavigate, createSearchParams } from "react-router-dom";
import * as EmailValidator from "email-validator";

export const useEmailAddressRegister = () => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [state, setState] = useState({
    fullName: "",
    fullNameStatus: "normal",
    fullNameErrorMessage: "",
    userName: "",
    userNameStatus: "normal",
    userNameErrorMessage: "",
    email: "",
    emailStatus: "normal",
    emailErrorMessage: "",
    phoneNumber: "",
    phoneNumberStatus: "normal",
    phoneNumberErrorMessage: "",
  });

  const handleForms = (field) => (e) => {
    setState({
      ...state,
      [field]: e.target.value,
    });
  };

  const handleRegister = () => {
    if (!state.fullName || state.fullName.length < 5) {
      setState({
        ...state,
        fullNameStatus: "error",
        fullNameErrorMessage: "Full Name must consist of 5 characters",
      });

      return;
    }

    if (!state.userName || state.userName.length < 5) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "error",
        userNameErrorMessage: "User Name must consist of 5 characters",
      });

      return;
    }

    if (!EmailValidator.validate(state.email)) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "normal",
        userNameErrorMessage: "",
        emailStatus: "error",
        emailErrorMessage:
          "Invalid email format, use @domain.com for email address",
      });

      return;
    }

    if (
      !state.phoneNumber ||
      state.phoneNumber.length < 10 ||
      state.phoneNumber.length > 13
    ) {
      setState({
        ...state,
        fullNameStatus: "normal",
        fullNameErrorMessage: "",
        userNameStatus: "normal",
        userNameErrorMessage: "",
        emailStatus: "normal",
        emailErrorMessage: "",
        phoneNumberStatus: "error",
        phoneNumberErrorMessage: "Mobile number must consist of 10-13 digit",
      });

      return;
    }

    setState({
      ...state,
      phoneNumberStatus: "normal",
      phoneNumberErrorMessage: "",
    });

    setShowModal(true);
  };

  const handleBackToSignIn = () => {
    navigate("/login/email-address");
  };

  return {
    showModal,
    setShowModal,
    state,
    handleForms,
    handleRegister,
    handleBackToSignIn,
  };
};
